import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";
import { FAQS } from "../data/content";

export const Faq = () => {
    const [openIdx, setOpenIdx] = useState(0);

    return (
        <section id="faq" data-testid="faq-section" className="bg-cream py-24 sm:py-32">
            <div className="mx-auto max-w-4xl px-5 sm:px-8">
                <SectionHead
                    eyebrow="Perguntas frequentes"
                    title="Arbitragem e mediação, sem juridiquês"
                    lead="Respostas diretas às dúvidas mais comuns de empresas, sócios e advogados sobre a resolução de conflitos fora do Poder Judiciário."
                />

                <div className="mt-14">
                    {FAQS.map((f, i) => {
                        const open = openIdx === i;
                        return (
                            <Reveal key={f.q} delay={0.04 * i}>
                                <div className="border-t border-cream-line last:border-b">
                                    <button
                                        type="button"
                                        data-testid={`faq-question-${i}`}
                                        onClick={() => setOpenIdx(open ? -1 : i)}
                                        aria-expanded={open}
                                        className="group flex w-full items-center justify-between gap-6 py-7 text-left"
                                    >
                                        <span
                                            className={`font-serif text-xl transition-colors duration-300 sm:text-2xl ${
                                                open
                                                    ? "text-gold-dark"
                                                    : "text-ink group-hover:text-gold-dark"
                                            }`}
                                        >
                                            {f.q}
                                        </span>
                                        <span
                                            className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-sm border transition-[transform,background-color,border-color] duration-300 ${
                                                open
                                                    ? "rotate-45 border-gold bg-gold text-graphite-deep"
                                                    : "border-cream-line text-graphite-text group-hover:border-gold"
                                            }`}
                                        >
                                            <Plus size={16} />
                                        </span>
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {open && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{
                                                    duration: 0.4,
                                                    ease: [0.22, 1, 0.36, 1],
                                                }}
                                                className="overflow-hidden"
                                            >
                                                <p
                                                    data-testid={`faq-answer-${i}`}
                                                    className="max-w-2xl pb-8 text-sm leading-relaxed text-graphite-text sm:text-base"
                                                >
                                                    {f.a}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
